module.exports = {
  title: "TheEv",
  favicon: "/logo.png",
  copyright: "© 2017 TheEv. All rights reserved." // Copyright string for the footer of the website
};



// WEBPACK FOOTER //
// ./data/SiteData.js